import { render, staticRenderFns } from "./CappedConnectivityPackagePrices.vue?vue&type=template&id=725ff6ce&scoped=true&"
import script from "./CappedConnectivityPackagePrices.vue?vue&type=script&lang=js&"
export * from "./CappedConnectivityPackagePrices.vue?vue&type=script&lang=js&"
import style0 from "./CappedConnectivityPackagePrices.vue?vue&type=style&index=0&id=725ff6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ff6ce",
  null
  
)

export default component.exports